import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash/omit';
import cx from 'classnames';
import Icon from 'components/Icon';
import ButtonUnstyled from 'components/ButtonUnstyled';
import {injectIntl, defineMessages} from 'react-intl';
import './InputWithIcon.css';

const MESSAGES = defineMessages({
  clear: {
    defaultMessage: 'Clear search text',
    id: 'InputWithIcon__ClearSearchTextLabel',
    description: 'Label for icon that clears the search text',
  },
});

class InputWithIcon extends React.Component {
  state = {
    isFocused: false,
    text: '',
  };

  UNSAFE_componentWillMount() {
    this.setState({text: this.props.value || ''});
  }

  componentDidMount() {
    if (this.props.focusOnMount) this.refs.input.focus();
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next.value !== this.props.value) {
      this.setState({text: next.value});
    }
  }

  handleFocus = e => {
    this.props.onFocus && this.props.onFocus(e);
    this.setState({isFocused: true});
  };

  handleBlur = () => {
    this.setState({isFocused: false});
  };

  handleInputChange = e => {
    this.setState({text: e.target.value}, () => {
      this.props.onInputChange(this.state.text);
    });
  };

  handleCancelClick = () => {
    this.setState({text: ''}, () => {
      this.props.onInputChange(this.state.text);
    });
  };

  render() {
    const {icon, canCancel, intl, ...rest} = this.props;
    const {isFocused, text} = this.state;

    return (
      <div
        className={cx({
          InputWithIcon: true,
          'InputWithIcon--active': isFocused,
        })}
      >
        <div
          className={cx({
            InputWithIcon__Icon: true,
            'InputWithIcon__Icon--active': isFocused,
          })}
        >
          {icon}
        </div>
        <input
          {...omit(rest, ['onInputChange', 'focusOnMount'])}
          ref="input"
          value={text}
          onChange={this.handleInputChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          type="text"
          className="InputWithIcon__Input"
        />
        {canCancel && text.length > 0 ? (
          <ButtonUnstyled
            onClick={this.handleCancelClick}
            title={intl.formatMessage(MESSAGES.clear)}
          >
            <Icon icon={Icon.OPTIONS.X} className="InputWithIcon__CancelX" />
          </ButtonUnstyled>
        ) : null}
      </div>
    );
  }
}

InputWithIcon.propTypes = {
  canCancel: PropTypes.bool.isRequired,
  focusOnMount: PropTypes.bool.isRequired,
  icon: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

InputWithIcon.defaultProps = {
  focusOnMount: false,
  canCancel: true,
};

export default injectIntl(InputWithIcon);
